type Props = {
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
  color?: React.CSSProperties["color"];
  rotation?: number;
};

function ArrowWithTail(props: Props) {
  const { width = "12", height = "8", color = "#1C1B1F", rotation = 0 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      <path
        d="M7.85668 7.11733L10.9043 4.06971M10.9043 4.06971L7.85668 1M10.9043 4.06971H0.999535"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ArrowWithTail;
